import { apiService } from "../../../../services/api";

export const getNotifications = async (params: {
  notification_type?: string;
  is_read?: boolean;
  priority?: "low" | "medium" | "high";
  limit?: number;
  offset?: number;
}) => {
  const queryParams = new URLSearchParams();
  if (params.notification_type)
    queryParams.append("notification_type", params.notification_type);
  if (params.is_read !== undefined)
    queryParams.append("is_read", String(params.is_read));
  if (params.priority) queryParams.append("priority", params.priority);
  if (params.limit !== undefined)
    queryParams.append("limit", String(params.limit));
  if (params.offset !== undefined)
    queryParams.append("offset", String(params.offset));
  return apiService.get(`/company/notifications?${queryParams.toString()}`);
};
export const markNotificationAsRead = async (notificationId: string) => {
  return apiService.post(`/company/notifications/${notificationId}/mark-read`);
};
export const markNotificationAllRead = async () => {
  return apiService.post(`/company/notifications/mark-all-read`);
};
